
import { Component } from "vue-property-decorator";
import AppComposeMixin from "./mixin";

/**
 * APP排版页面
 * 品牌方版本见 merchant.vue（独立组件 name，缓存互不干扰）
 */
@Component({ name: 'app-compose-index', inject: [] })
export default class AppComposeIndex extends AppComposeMixin {}
